import { FleetPageReducer } from "./pages/drones-page/redux";
import { droneFeatureApi } from "./redux/api";

export const FleetFeatureMiddlewares = [
];

export const FleetFeatureReducers = {
  FleetPageReducer,
  [droneFeatureApi.reducerPath]: droneFeatureApi.reducer,
};
